import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import DeviceService from '~/services/device'
import { maxSizes } from '~/models/Responsive'

export const useDeviceStore = defineStore('device', () => {
	const isMobile = ref(DeviceService.isMobile())
	const width = ref(isMobile.value ? maxSizes.xs : maxSizes.lg)
	const xsMaxWidth = maxSizes.xs

	const isXS = computed(() => width.value <= xsMaxWidth)

	function updateSize(size: number) {
		width.value = size
	}

	return {
		isXS,
		isMobile,
		updateSize,
	}
})
